import styled from 'styled-components'
import tw from "tailwind-styled-components";
const Wrapper = tw.div`
w-1/2 hidden lg:block bg-[#BDFFC4]
`
export default Wrapper
